import React, { memo, useCallback, useMemo } from 'react';
/** REDUX */
/** COMPONENTS */
import IncidentWrapper from '../../../pages/Incidents/Calendar/IncidentWrapper';
import * as IncidentShowMoreModalUI from './IncidentShowMoreModalUI';
/** UTILS */
import TimezonePopup from '../../TimezonePopup';
import { assertNotNil, GraphQLDate } from '../../../utils/types';
import { useAppSelector } from '../../../redux/hooks';
import { selectModalData } from '../../../redux/selectors/modal';
import { globalFormat } from '../../../utils/formatting';

export default memo(function IncidentShowMoreModal() {
  const { dateFormat } = globalFormat.getGlobalFormat();
  const modalData = useAppSelector(selectModalData);
  const { incidents, date } = modalData;
  assertNotNil(date);

  const parseDate = useCallback(
    (newDate: GraphQLDate) => (
      <TimezonePopup timestamp={newDate} dateFormat={dateFormat} />
    ),
    [dateFormat],
  );

  const parsedDate = useMemo(() => parseDate(date), [parseDate, date]);

  const renderEvents = useMemo(
    () =>
      incidents?.map((incident: any) => (
        <IncidentWrapper key={incident.id} incident={incident}>
          <div className={'rbc-event'} tabIndex={0}>
            <div className={'rbc-event-content'} title={incident.name}>
              {incident.name}
            </div>
          </div>
        </IncidentWrapper>
      )),
    [incidents],
  );

  return (
    <IncidentShowMoreModalUI.Container>
      <IncidentShowMoreModalUI.DateWrapper>
        {parsedDate}
      </IncidentShowMoreModalUI.DateWrapper>
      <IncidentShowMoreModalUI.Content>
        {renderEvents}
      </IncidentShowMoreModalUI.Content>
    </IncidentShowMoreModalUI.Container>
  );
});
